import React from 'react';
import { View } from 'react-native';
import Svg, { Path, Rect } from 'react-native-svg';

const PullCREDsIcon = ({ height = 32, width = 32, color = "#000" }) => {
    return (
        <View>
            <Svg
                height={height}
                width={width}
                viewBox="0 0 32 32"
                fill={color}
            >
                <Path d="M15,19.509l-3.254-3.254l0.509-0.509L15,18.491l5.745-5.746l0.51,0.509L15,19.509z M23.314,28.36H31  
          c0.119,0,0.231-0.06,0.298-0.158c0.067-0.1,0.081-0.225,0.036-0.336L30.388,25.5l0.946-2.366c0.045-0.111,0.031-0.236-0.036-0.336  
          C31.231,22.699,31.119,22.64,31,22.64h-2.265C29.8,20.601,30.36,18.317,30.36,16c0-7.918-6.442-14.36-14.36-14.36  
          S1.64,8.082,1.64,16c0,2.317,0.56,4.601,1.625,6.64H1c-0.12,0-0.231,0.06-0.298,0.158c-0.067,0.1-0.08,0.225-0.036,0.336L1.612,25.5  
          l-0.947,2.366c-0.044,0.111-0.031,0.236,0.036,0.336C0.769,28.301,0.88,28.36,1,28.36h7.686c2.208,1.309,4.734,2,7.314,2  
          S21.106,29.669,23.314,28.36z M21.775,28.36c-3.598,1.68-7.953,1.68-11.55,0H21.775z M2.334,25.634c0.034-0.086,0.034-0.182,0-0.268  
          L1.532,23.36h28.937l-0.803,2.006c-0.034,0.086-0.034,0.182,0,0.268l0.803,2.006H1.532L2.334,25.634z M27.36,16  
          c0-6.264-5.097-11.36-11.36-11.36C9.736,4.64,4.64,9.736,4.64,16c0,2.385,0.756,4.715,2.142,6.64h-2.7  
          C2.955,20.62,2.36,18.328,2.36,16C2.36,8.479,8.479,2.36,16,2.36S29.64,8.479,29.64,16c0,2.328-0.595,4.62-1.723,6.64h-2.699  
          C26.604,20.716,27.36,18.385,27.36,16z M5.36,16c0-5.867,4.773-10.64,10.64-10.64S26.64,10.133,26.64,16  
          c0,2.411-0.824,4.762-2.325,6.64H7.686C6.185,20.762,5.36,18.41,5.36,16z"/>
                <Rect width="32" height="32" fill="none" />
            </Svg>
        </View>
    );
};

export default PullCREDsIcon;
